import React from "react";

import SkillTile from "./skillTile";

export default ({ skills, sectionName, heading }) => (
  <section
    className="colorlib-services"
    data-section={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
    id={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
  >
    <div className="colorlib-narrow-content">
      <div className="row">
        <div className="col-md-6 col-md-offset-3 col-md-pull-3">
          <span className="heading-meta">{sectionName}</span>
          <h2 className="colorlib-heading">{heading}</h2>
        </div>
        <div className="row row-pt-md">
          {skills.map((skill, i) => <SkillTile {...skill} key={i} />)}
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/skillsContainer.js